Popovers = LP.module 'Popovers'

Popovers.howToCollectionBuilderOnSearch = ->
  @_bindAdjustPopoverZIndexOnSearch()
  @_initCreateCollectionPopover()

  $('#js-cb-how-to-info').on 'show.bs.popover', ->
    Popovers._showCurriculumManagerButtonPopover()
    Popovers._showDragResourcePopover()
    # To prevent the popovers appear over the header if the CB is not at its
    # initial position (scrolled down)
    Popovers._adjustCBPopoverZIndexOnSearch()
    $('body')[0].addEventListener('click', Popovers._closeHowToPopoverOnSearchPage)

  $('#js-cb-how-to-info').on 'hide.bs.popover', ->
    Popovers._hideCurriculumManagerButtonPopover()
    Popovers._hideDragResourcePopover()
    $('body')[0].removeEventListener('click', Popovers._closeHowToPopoverOnSearchPage)

Popovers._initCreateCollectionPopover = ->
  $('#js-cb-how-to-info')
    .popover(
      placement: 'bottom',
      container: '#collection-builder-area',
      html: 'true',
      title: '1. Create or open a Collection.',
      content: '<div class="create-col-img" />',
      template: Popovers._howToTemplate('create-collections')
    )

Popovers._showCurriculumManagerButtonPopover = ->
  cssClass = if LP.config.logged_in then 'cm-builder-button' else 'visitor-cm-builder-button'
  $('#collection-builder-button')
    .popover(
      trigger: 'manual',
      placement: 'left',
      container: '#collection-builder-area',
      html: 'true',
      title: '3. Manage your Collections and other resources.',
      content: '<div class="title-img" />',
      template: Popovers._howToTemplate(cssClass)
    )
    .popover('show')

Popovers._draggableResource = ->
  index = if $('.panel-resource').length <= 2 then 0 else 2
  $('.panel-resource:eq('+index+')')

# We're not showing the popover on the second search item because it
# overlaps with another popover on tile layout.
# It's either the 1st or the 3rd item that gets the popover.
Popovers._showDragResourcePopover = ->
  action_name = if LP.config.isDesktop then 'Drag' else 'Add'
  @_draggableResource()
    .popover(
      trigger: 'manual',
      placement: 'top',
      container: '#search-results',
      html: 'true',
      title: "2. #{action_name} search results to Collection",
      content: '<div class="drag-resource-img" />',
      template: Popovers._howToTemplate('drag-resource')
    )
    .popover('show')

Popovers._hideCreateCollectionPopover = ->
  $('#js-cb-how-to-info').popover('hide')

Popovers._hideCurriculumManagerButtonPopover = ->
  $('#collection-builder-button').popover('hide')

Popovers._hideDragResourcePopover = ->
  # drag resource popover is tricky to close this is what works best.
  $('.popover.how-to-popover.drag-resource').remove()

Popovers._closeHowToPopoverOnSearchPage = (e) ->
  # We don't close the popovers if the 'i' or the Learn More button or the popover are clicked.
  unless e.target.id == 'js-cb-how-to-info' || e.target.id == 'learn-more-button' || $(e.target).closest('.how-to-popover')[0]
    Popovers._hideCurriculumManagerButtonPopover()
    Popovers._hideDragResourcePopover()
    Popovers._hideCreateCollectionPopover()

Popovers._bindAdjustPopoverZIndexOnSearch = ->
  $(window).on 'scroll', ->
    Popovers._adjustCBPopoverZIndexOnSearch()

  $('#header-wrap').on 'headroom.unpinned', ->
    Popovers._adjustCBPopoverZIndexOnSearch()

  $('#header-wrap').on 'headroom.pinned', ->
    Popovers._adjustCBPopoverZIndexOnSearch()

Popovers._adjustCBPopoverZIndexOnSearch = ->
  if $('.popover.cm-builder-button')[0]
    # the "i" icon popover & cm button are always present.
    # we're not intereseted in the "i" popover because it never gets under the
    # header. It's attached to the builder.
    arry = [
      [$('#collection-builder-button').offset().top, $('.popover.cm-builder-button')],
      [$('#collection-builder-area').offset().top, $('.popover.create-collections')]
    ]

    # the drag popover appears only if we have at least one search result.
    if $('.popover.drag-resource')[0]
      arry.push([@_draggableResource().offset().top, $('.popover.drag-resource')])

    @updateHowToPopoversVisibility(arry)
